import { getRoundedNumber } from '../../../../../shared/utils/mathUtils';
import { RecipeMacros } from '../../../../interfaces/RecipeMacros';
import { RECIPE_MACRO_KEYS } from '../../constants/recipeMacros';
import {
  RecipeFormValues,
  RecipeIngredientFormValue,
} from '../../interfaces/RecipeFormValues';
import { getIngredientTotals } from '../getIngredientTotals/getIngredientTotals';

export type CalculatedRecipeMacros = {
  total: RecipeMacros;
  perServing: RecipeMacros;
};

const DISPLAY_ROUNDING_PRECISION = 1;

const mapMacros = (getValue: (key: keyof RecipeMacros) => number): RecipeMacros =>
  Object.fromEntries(
    RECIPE_MACRO_KEYS.map((key) => [key, getValue(key)]),
  ) as RecipeMacros;

/** Display only - the backend computes and stores its own values on save. */
export const calculateRecipeMacros = (
  ingredients: RecipeIngredientFormValue[],
  servingSize: RecipeFormValues['servingSize'],
): CalculatedRecipeMacros => {
  const ingredientTotals = ingredients.map(({ perUnit, amount }) =>
    getIngredientTotals(perUnit, amount),
  );
  const total = mapMacros((key) =>
    ingredientTotals.reduce((sum, totals) => sum + totals[key], 0),
  );
  // an empty or 0 servings field is still being typed; its own validation reports it
  const servings = Math.max(1, servingSize || 0);

  return {
    total: mapMacros((key) => getRoundedNumber(total[key], DISPLAY_ROUNDING_PRECISION)),
    perServing: mapMacros((key) =>
      getRoundedNumber(total[key] / servings, DISPLAY_ROUNDING_PRECISION),
    ),
  };
};
